module.exports = __webpack_public_path__ + "static/media/hidden-filter-icon.4b6efc82.svg";